import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/ibutton/ibutton.scss";
import IbuttonTable from "./ibuttonTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import RoleAccessBadge from "../common/roleAccessBadge";

class Ibutton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ibuttonList: [],
      searchKey: "",
      pageCount: 0,
      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "1",
      entryEnd: "50",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,
      stateFilter: "all",
    };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
  }

  componentDidMount() {
    var urlAll = "";

    let query = encodeQueryData(this.setIbuttonQueryObject());
    urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  }

  handleShowEntries = (inputShowEntries) => {
    this.pageSize = inputShowEntries;

    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;

    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  setIbuttonQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;

    return data;
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  handleSearch = (inputSearch) => {
    if (inputSearch == "") {
      this.setState({ filterMessage: false });
    } else {
      this.setState({ filterMessage: true });
    }

    this.searchText = inputSearch;
    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  getIbutton = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      let ibuttonList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("list", ibuttonList);
      this.setState({
        ibuttonList: ibuttonList.data,
        pageCount: JSON.parse(ibuttonList.headers.pagination).totalPages,
      });
      this.handleShowResults(ibuttonList);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }else{
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleShowResults = (ibuttonList) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(ibuttonList.headers.pagination).totalItems,
    });
    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(ibuttonList.headers.pagination).totalItems,
        totalFilter: true,
      });
    }
    this.setState({
      entryStart: (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });
    if (
      JSON.parse(ibuttonList.headers.pagination).totalItems <
      parseInt(this.state.entryEnd)
    ) {
      this.setState({
        entryEnd: JSON.parse(ibuttonList.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(ibuttonList.headers.pagination).currentPage) *
        parseInt(this.pageSize);
      this.setState({ entryEnd: value });
    }
    if (
      this.state.entryEnd >
      parseInt(JSON.parse(ibuttonList.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEnd: JSON.parse(ibuttonList.headers.pagination).totalItems,
      });
    }
    if (this.state.ibuttonList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };


  normalizeConnectionState = (state) => {
    const normalizedState = (state || "").toString().toLowerCase();

    if (normalizedState === "connected") {
      return "connected";
    }

    if (normalizedState === "disconnected") {
      return "disconnected";
    }

    return "unknown";
  };

  getStateCounts = () => {
    return this.state.ibuttonList.reduce(
      (counts, ibutton) => {
        const state = this.normalizeConnectionState(ibutton.state);

        counts.all += 1;

        if (state === "connected") {
          counts.connected += 1;
        }

        if (state === "disconnected") {
          counts.disconnected += 1;
        }

        return counts;
      },
      { all: 0, connected: 0, disconnected: 0 }
    );
  };

  getFilteredIbuttons = () => {
    if (this.state.stateFilter === "all") {
      return this.state.ibuttonList;
    }

    return this.state.ibuttonList.filter(
      (ibutton) =>
        this.normalizeConnectionState(ibutton.state) === this.state.stateFilter
    );
  };

  handleStateFilter = (stateFilter) => {
    this.setState({ stateFilter });
  };


  render() {
    const { pageCount } = this.state;
    const filteredIbuttons = this.getFilteredIbuttons();
    const isStateFiltered = this.state.stateFilter !== "all";
    const stateCounts = this.getStateCounts();
    const stateFilters = [
      { key: "all", label: "All", count: stateCounts.all },
      { key: "connected", label: "Connected", count: stateCounts.connected },
      { key: "disconnected", label: "Disconnected", count: stateCounts.disconnected },
    ];

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All iButtons </title>
          </Helmet>
          <div className="contentBody ibutton-page-shell">
            <div className="contentWrapper ibutton-page">
              <div className="ibutton-page-header">
                <div>
                  <h2>iButtons</h2>
                  <p>Manage driver identification keys, linked assets and connection state.</p>
                </div>
                <RoleAccessBadge role="SystemAdmin" />
              </div>

              <div className="ibutton-toolbar">
                <div className="ibutton-search">
                  <i className="fa fa-search"></i>
                  <Form.Control
                    aria-label="Start typing to filter iButtons"
                    onChange={(event) => this.handleSearch(event.target.value)}
                    placeholder="Search iButtons by customer, serial, name, asset or status"
                    type="text"
                  />
                </div>

                <div className="ibutton-state-filter" role="group" aria-label="Filter iButtons by connection state">
                  <span>Page</span>
                  {stateFilters.map((filter) => (
                    <button
                      className={this.state.stateFilter === filter.key ? "active" : ""}
                      key={filter.key}
                      onClick={() => this.handleStateFilter(filter.key)}
                      type="button"
                    >
                      {filter.label}
                      <strong>{filter.count}</strong>
                    </button>
                  ))}
                </div>
              </div>

              <div className="ibutton-table-shell">
                <IbuttonTable
                  customers={filteredIbuttons}
                  sortFunction={this.handleSort}
                ></IbuttonTable>
              </div>
              <div className="ibutton-pagination">
                <ShowingResults
                  currentEntryStart={
                    isStateFiltered && filteredIbuttons.length === 0
                      ? 0
                      : isStateFiltered
                      ? 1
                      : this.state.entryStart
                  }
                  currentEntryEnd={
                    isStateFiltered ? filteredIbuttons.length : this.state.entryEnd
                  }
                  totalEntries={
                    isStateFiltered ? filteredIbuttons.length : this.state.totalEntry
                  }
                  totalFilterEntries={
                    isStateFiltered ? stateCounts.all : this.state.totalEntryFilter
                  }
                  filterMessage={this.state.filterMessage || isStateFiltered}
                />
                <Paginations
                  onPagination={this.handlePagination}
                  pageCount={pageCount}
                  pageRange={5}
                ></Paginations>
              </div>

            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Ibutton);
// <IbuttonTable
//     customers={ibuttonList}
//     onDetail={this.handleDetail}
//     sortFunction={this.handleSort}
// >
// </IbuttonTable>
